import { AnimationOptions } from 'ngx-lottie';

export interface ILoaderConfig {
  backdropBorderRadius?: string;
  backdropBackgroundColour?: string;
  fullScreenBackdrop?: boolean;
  animationType?: string;
  primaryColour?: string;
  secondaryColour?: string;
  tertiaryColour?: string;
  style?: string;
  size?: string;
  lottie?: AnimationOptions;
}

export class LoaderConfig implements ILoaderConfig {
  backdropBorderRadius?: string;
  backdropBackgroundColour?: string;
  fullScreenBackdrop?: boolean;
  animationType?: string;
  primaryColour?: string;
  secondaryColour?: string;
  tertiaryColour?: string;
  style?: string;
  size?: string;
  lottie?: AnimationOptions;

  constructor(config: ILoaderConfig = {}) {
    this.backdropBorderRadius = config.backdropBorderRadius;
    this.backdropBackgroundColour = config.backdropBackgroundColour;
    this.fullScreenBackdrop = config.fullScreenBackdrop;
    this.animationType = config.animationType;
    this.primaryColour = config.primaryColour;
    this.secondaryColour = config.secondaryColour;
    this.tertiaryColour = config.tertiaryColour;
    this.style = config.style;
    this.size = config.size;
    this.lottie = config?.lottie;
  }
}

export const loadingAnimationTypes = {
  chasingDots: 'chasing-dots',
  circle: 'sk-circle',
  circleSwish: 'circleSwish',
  cubeGrid: 'sk-cube-grid',
  doubleBounce: 'double-bounce',
  none: 'none',
  pulse: 'pulse',
  rectangleBounce: 'rectangle-bounce',
  rotatingPlane: 'rotating-plane',
  threeBounce: 'three-bounce',
  wanderingCubes: 'wandering-cubes',
  simple: 'simple',
  custom: 'custom',
  lottie: 'lottie'
};

export const loadingStyle = {
  light: 'light',
  dark: 'dark'
};

export const loadingSize = {
  small: 'small',
  large: 'large'
};
